<script>
    // Import Swiper Svelte components
    import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper";
    import { Swiper, SwiperSlide } from "swiper/svelte/swiper-svelte.js";
    import "swiper/swiper-bundle.min.css";
    // swiper core styles
    import "swiper/swiper.min.css";
    import { onMount } from "svelte";
    // modules styles
    import "swiper/modules/navigation/navigation.min.css";
    import "swiper/modules/pagination/pagination.min.css";
    let mobile = window.innerWidth < 768;
</script>

<div>
    <Swiper
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView="1"
        autoplay={{
            delay: 100000,
            disableOnInteraction: false,
        }}
        loop={true}
        loopFillGroupWithBlank={true}
        pagination={{
            clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        class="mySwiper"
    >
        <SwiperSlide>
            <a href="/nba/projections" class="text-decoration-none">
                <div class="bg-white mb-4 h-100 px-5">
                    <h5 class="card-title">Projections</h5>
                    <p class="card-text text-dark">
                        This is a wider card with supporting text below as a
                        natural lead-in to additional content. This content
                        is a little bit longer.
                    </p>
                </div>
            </a>
        </SwiperSlide>
        <SwiperSlide>
            <a href="/nba/fantasy/daily/optimizer" class="text-decoration-none">
                <div class="bg-white mb-4 h-100 px-5">
                    <h5 class="card-title">Optimizer</h5>
                    <p class="card-text text-dark">
                        This is a wider card with supporting text below as a
                        natural lead-in to additional content. This content
                        is a little bit longer.This is a wider card with supporting text below as a natural
                        lead-in to
                        additional content. This content is a little bit longer.
                        This is a wider card with supporting text below as a natural lead-in to
                        additional content. This content is a little bit longer.
                    </p>
                </div>
            </a>
        </SwiperSlide>
    </Swiper>
</div>
